import { QueryClient } from '@tanstack/react-query';
import { QUERY_KEYS, SECOND } from '../../constants';
import { getData } from '../../utils/api';
import { BetslipWithBetsExtendedInfo, PaginatedData, ResponseData, Sport } from '../../@types';

const LIVE_SPORTS_PARAMS = { isLive: true } as const;
const PRE_MATCH_SPORTS_PARAMS = { isLive: false } as const;
const MY_BETS_FIRST_PAGE = 1;
const MY_BETS_PAGE_LIMIT = 10;

export const prefetchLiveSports = (queryClient: QueryClient) => {
  return queryClient.prefetchQuery({
    queryKey: [QUERY_KEYS.sports, LIVE_SPORTS_PARAMS],
    queryFn: (): Promise<ResponseData<Sport>> => getData('sports/with-events', LIVE_SPORTS_PARAMS),
    staleTime: 60 * SECOND,
  });
};

export const prefetchPreMatchSports = (queryClient: QueryClient) => {
  return queryClient.prefetchQuery({
    queryKey: [QUERY_KEYS.sports, PRE_MATCH_SPORTS_PARAMS],
    queryFn: (): Promise<ResponseData<Sport>> => getData('sports/with-events', PRE_MATCH_SPORTS_PARAMS),
    staleTime: 60 * SECOND,
  });
};

export const prefetchFeaturedSportLandingEvents = async (queryClient: QueryClient) => {
  const preMatch = queryClient.getQueryData<ResponseData<Sport>>([QUERY_KEYS.sports, PRE_MATCH_SPORTS_PARAMS]);
  const featuredSportId = preMatch?.items?.[0]?.id;

  if (!featuredSportId) {
    return;
  }

  const queryParams = {
    limit: 25,
    sportId: featuredSportId,
    featured: true,
    sort: 'startDate',
    count: false,
  };

  await queryClient.prefetchQuery({
    queryKey: [QUERY_KEYS.featuredEvents, 'neobet-landing', featuredSportId],
    queryFn: () => getData('events/published', queryParams),
    staleTime: 60 * SECOND,
  });
};

export const prefetchOpenMyBetsFirstPage = (queryClient: QueryClient) => {
  return queryClient.prefetchQuery({
    queryKey: [QUERY_KEYS.myBets, 'open', MY_BETS_FIRST_PAGE],
    queryFn: (): Promise<PaginatedData<BetslipWithBetsExtendedInfo>> =>
      getData('betting-slips/my-bets', {
        resolvedStatus: 'open',
        limit: MY_BETS_PAGE_LIMIT,
        page: MY_BETS_FIRST_PAGE,
      }),
    staleTime: 30 * SECOND,
  });
};
